export const associationEmail = 'fantasti3d@gmail.com';

export const socialLinks = [
  { id: 'instagram', name: 'Instagram', label: '@fantasti100', url: 'https://www.instagram.com/fantasti100/' },
  { id: 'facebook', name: 'Facebook', label: 'Associazione Fantasti100', url: 'https://www.facebook.com/fantasti100/' },
  { id: 'tiktok', name: 'TikTok', label: '@fantasti100ass', url: 'https://www.tiktok.com/@fantasti100ass' },
  { id: 'youtube', name: 'YouTube', label: 'Matteo Taddia · video dei carri', url: 'https://www.youtube.com/@matteotaddia7422' },
];

export const associationAddress = {
  street: 'Via Manin, 13',
  locality: '44042 Cento (FE), Italia',
  source: 'https://exa.ai/library/place/75pkzm1xrv8',
  mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Associazione+Carnevalesca+Fantasti100+Via+Manin+13+Cento',
  embedUrl: 'https://www.google.com/maps?q=' + encodeURIComponent('Via Manin 13, 44042 Cento FE, Italia') + '&z=16&output=embed',
};